//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import heroCarouselStyle from "../../assets/jsStyle/heroCarouselStyle";

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    const SellerServices = [
        t('aboutUsPage.list1Item1'),
        t('aboutUsPage.list1Item2'),
        t('aboutUsPage.list1Item3'),
        t('aboutUsPage.list1Item4'),
        t('aboutUsPage.list1Item5'),
        t('aboutUsPage.list1Item6')
    ] as string[];

    const BuyerServices = [
        t('aboutUsPage.list2Item1'),
        t('aboutUsPage.list2Item2'),
        t('aboutUsPage.list2Item3'),
        t('aboutUsPage.list2Item4'),
        t('aboutUsPage.list2Item5')
    ] as string[];

    return (
        <div className="row">
            <div className="col-12 mb-3 mb-lg-5">
                <h2 className="mb-lg-4">{t('aboutUsPage.title1')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
            </div>
            <div className="col-12 px-0">
                <h2 className="mb-lg-4">{t('aboutUsPage.title2')}</h2>
                <Slider {...{...heroCarouselStyle, dots: true, arrows: false}}>
                    <div className="row d-flex mx-0 px-3">
                        <div className="col-12 col-lg-6 bg-cuge-grill">
                            <div className="p-3">
                                <h3>{t('aboutUsPage.subTitle1')}</h3>
                                <ul>
                                    {SellerServices.map((service, index) => (
                                        <li key={index} className="mb-2" dangerouslySetInnerHTML={{ __html: service }}></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 px-0">
                            <div className="img-wrapper">
                                <img src="/assets/images/altrePag/service-vendi.webp" alt={t('aboutUsPage.imageAlt1') as string} />
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex mx-0 px-3">
                        <div className="col-12 col-lg-6 bg-cuge-grill">
                            <div className="p-3">
                                <h3>{t('aboutUsPage.subTitle2')}</h3>
                                <ul>
                                    {BuyerServices.map((service, index) => (
                                        <li key={index} className="mb-2" dangerouslySetInnerHTML={{ __html: service }}></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 px-0">
                            <div className="img-wrapper">
                                <img src="/assets/images/altrePag/service-compra.webp" alt={t('aboutUsPage.imageAlt2') as string} />
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </div>
    )
};
export default AboutUsMain;